export default "__VITE_ASSET__Bg14xEm1__"